import { ArrowLeft, PanelRightClose } from "lucide-react";
import { Button } from "~/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "~/components/ui/tooltip";
import { PlanChecklist } from "~/pages/manifold-nextgen/components/conversations/PlanChecklist";
import type { PlanTask } from "~/pages/manifold-nextgen/components/conversations/derivePlan";

interface SessionContextPlanDetailProps {
  plan: PlanTask[];
  // Whether the agent is currently running — forwarded to the checklist so the
  // in-progress step only spins while a turn is in flight.
  isActive: boolean;
  onBack: () => void;
  onCollapse: () => void;
}

// The session's current task plan, reached from the single Apps > Plan entry.
// The plan is derived from the conversation's Planning-capability tool calls
// (see `useSessionPlan`); this view is a static header around `PlanChecklist`.
export const SessionContextPlanDetail = ({
  plan,
  isActive,
  onBack,
  onCollapse,
}: SessionContextPlanDetailProps) => {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex h-14 shrink-0 items-center gap-1 border-b border-border px-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={onBack}
          aria-label="Back to session context"
          className="size-8"
        >
          <ArrowLeft className="size-4" />
        </Button>
        <span className="truncate text-sm font-medium text-foreground">Plan</span>
        <Tooltip delayDuration={700}>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              onClick={onCollapse}
              aria-label="Collapse session context"
              className="ml-auto size-8"
            >
              <PanelRightClose className="size-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="bottom">Toggle Context</TooltipContent>
        </Tooltip>
      </div>

      <div className="flex-1 overflow-y-auto p-3">
        {plan.length === 0 ? (
          <p className="p-4 text-center text-xs italic text-muted-foreground/80">No plan yet.</p>
        ) : (
          <PlanChecklist tasks={plan} isActive={isActive} />
        )}
      </div>
    </div>
  );
};
